import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import ProfileUpdateLottie from "../../../Animation/ProfileUpdateLottie/ProfileUpdateLottie";
import "./ProfileUpdateModal.css";

function ProfileUpdateModal({ baseLink, ...props }) {

  return (
    <section className="ProfileUpdateModal modal-holder">
      <Modal
        {...props}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="ProfileUpdateModal modal-holder"
      >
        <Modal.Body>
          <div className="success_main_div">
            <div className="success_loottie_holder">
              <ProfileUpdateLottie />
            </div>
            <div className="success_content_holder">
              <div className="text_holder">
                <p className="heading">{props?.successText}</p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default ProfileUpdateModal;
